import { generators } from '@playcastdotio/Messaging';
import { ipcSend } from '../../../../api/messaging/protocols/ipc';
import type { PlaycastKeyDetail } from '@playcastdotio/CoreTypes';
import * as keycode from 'keyboard-key';

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function createKeyDetail(keyCode: number, shift: boolean): PlaycastKeyDetail {
  return {
    keyCode,
    location: 'standard',
    source: { type: 'keyboard', code: keyCode },
    modifiers: { ctrl: false, alt: false, shift, meta: false },
    displayName: 'host',
  };
}

function sendKeyDown(keyCode: number, shift: boolean): void {
  ipcSend(generators.keyboard.down('host', createKeyDetail(keyCode, shift)));
}

function sendKeyUp(keyCode: number, shift: boolean): void {
  ipcSend(generators.keyboard.up('host', createKeyDetail(keyCode, shift)));
}

async function sendKeyPress(keyCode: number, shift: boolean, hold: number): Promise<void> {
  sendKeyDown(keyCode, shift);
  await delay(hold);
  sendKeyUp(keyCode, shift);
  await delay(20);
}

const SHIFT_REQUIRED_CHARS = new Set([
  ')', '!', '@', '#', '$', '%', '^', '&', '*', '(',
  '_', '+', '{', '}', ':', '"', '<', '>', '?', '|',
]);

export class MacroKeyboardEmitter {
  public async sendKeyPress(keyCode: number, shift: boolean, hold: number): Promise<void> {
    await sendKeyPress(keyCode, shift, hold);
  }

  public async sendKeyString(text: string): Promise<void> {
    for (const char of text) {
      const code = keycode.getCode(char);
      if (!code) continue;

      const shift =
        (char === char.toUpperCase() && char !== char.toLowerCase()) ||
        SHIFT_REQUIRED_CHARS.has(char);

      if (shift) {
        sendKeyDown(16, shift);
        await delay(20);
      }

      await sendKeyPress(code, shift, 20);

      if (shift) {
        sendKeyUp(16, shift);
        await delay(20);
      }
    }
  }
}
